import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  .input-container {
    max-width: 754px;
    margin: auto;
    aspect-ratio: 3/4;
  }
  .ant-input {
    padding: 24px;
    font-family: inherit !important;
    font-weight: 700;
  }
  .input-label {
    margin: 0;
    margin-bottom: 16px;
    font-size: 18px;
    font-weight: 700;
  }
  .custom-button {
    margin: 24px auto;
  }
  .copy-button {
    display: flex !important;
    justify-content: center;
    align-items: center;
    column-gap: 8px;
    font-weight: 500;
    cursor: pointer;
  }
  .anticon svg {
    font-size: 20px;
  }
  .ant-alert {
    margin-bottom: 24px;
  }
  .ant-tabs-bar {
    display: flex;
    justify-content: center;
    border:none;
  }
`;
